import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcFileSizeInKb',
  standalone: false
})
export class CalcFileSizeInKbPipe implements PipeTransform {

  transform(sizeInBytes: number): string {
    let size = (sizeInBytes / 1024);
    let sizeName = 'KB';

    if (size > 1024) {
      size = (size / 1024);
      sizeName = 'MB';
    }

    return `${size.toFixed(0)} ${sizeName}`;
  }

}
